/**
 * Flags that exist for demonstrations and must be off in production.
 *
 * Kept in their own file, one constant each, so "what is switched on for the
 * demo?" is answered by opening one short file rather than grepping the app.
 * Every flag here is listed in infra/DEPLOY.md's go-live checklist.
 */

/**
 * Show a link to the admin dashboard in the assessment's footer.
 *
 * ON for demos, so the dashboard can be reached in one click while presenting.
 *
 * OFF before this is public. The dashboard is password-protected, so the link
 * leaks no data — but it is a client-facing page for business owners, and a
 * visible staff entrance on it looks unfinished. Set to `false` and redeploy.
 */
export const SHOW_ADMIN_LINK = false;
